import React from 'react';
import {
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Table,
  Collapse,
  IconButton,
  Box,
} from 'components/mui';
import { ExpandMore, ExpandLess } from 'components/icons';
import { DateGroupRow } from 'containers/pages/payrollReport/types';
import ShiftRow from './ShiftRow';

interface DateRowProps {
  row: DateGroupRow;
  reportType: 'guard' | 'consultant' | '';
  isExpanded: boolean;
  onToggle: (id: string) => void;
  childColumns: { id: string; label: string; width: string }[];
}

function DateRow({ row, reportType, isExpanded, onToggle, childColumns }: DateRowProps) {
  const totalCols = reportType === 'guard' ? 3 : 4;

  return (
    <>
      <TableRow
        hover
        onClick={() => onToggle(row.id)}
        sx={{ cursor: 'pointer', '& > *': { borderBottom: 'unset' } }}
      >
        <TableCell sx={{ width: '5%' }}>
          <IconButton
            aria-label={isExpanded ? 'Collapse' : 'Expand'}
            aria-expanded={isExpanded}
            size="small"
          >
            {isExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </TableCell>
        <TableCell sx={{ fontWeight: 600 }}>{row.formattedDate}</TableCell>
        {reportType === 'guard' ? (
          <TableCell>{row.totalHours}</TableCell>
        ) : (
          <>
            <TableCell>{row.totalHoursRT}</TableCell>
            <TableCell>{row.totalHoursOT}</TableCell>
          </>
        )}
      </TableRow>

      <TableRow>
        <TableCell sx={{ p: 0 }} colSpan={totalCols}>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box sx={{ mx: 1, mb: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {childColumns.map((col) => (
                      <TableCell
                        key={col.id}
                        sx={{
                          width: col.width,
                          fontWeight: 600,
                          fontSize: '0.8rem',
                          color: 'text.secondary',
                        }}
                      >
                        {col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.children.map((child) => (
                    <ShiftRow key={child.id} row={child} reportType={reportType} />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default DateRow;
